import TopHeaderSwiper from "@/components/global/swiper/TopHeaderSwiper";
import LocaleSwitcher from "@/components/global/buttons/LocaleSwitcher";
import FastDeliveryIcon from "@/components/icons/FastDeliveryIcon";
import PaySecurelyIcon from "@/components/icons/PaySecurelyIcon";
import ContactUsIcon from "@/components/icons/ContactUsIcon";
import LangIcon from "@/components/icons/LangIcon";
import GpsIcon from "@/components/icons/GpsIcon";

import { useTranslation } from "next-i18next";
import Link from "next/link";
import useScreenSize from "@/hooks/display/useDisplay";
import { ModalContext } from "@/pages/_app";
import { useContext } from "react";
import ServiceDropdown from "./ServiceDropdown";

const Header = ({ headerJson }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation("common");

  const { isResponsive } = useScreenSize();
  const Context = useContext(ModalContext);
  return (
    <>
      <header className="relative w-full py-3 bg-primary">
        <div className="flex items-center justify-between w-11/12 mx-auto text-white">
          <div className="items-center hidden text-sm lg:flex">
            <div
              className={`flex items-center cursor-pointer gap-1.5 ${
                language === "en" ? "pr-2 border-r" : "pl-2 border-l"
              } border-white`}
              onClick={() => {
                Context?.dispatch({ type: "trackOrder" });
              }}
            >
              <GpsIcon className="size-4" />
              <span>{t("Track Your Order")}</span>
            </div>
            <div
              className={`flex items-center gap-1.5 px-2 ${
                language === "en" ? "border-r" : "border-l"
              } border-white`}
            >
              <PaySecurelyIcon className="size-4" />
              <span>{t("Pay Securely")}</span>
            </div>
            <div
              className={`flex items-center gap-1.5 ${
                language === "en" ? "pl-2" : "pr-2"
              }`}
            >
              <FastDeliveryIcon className="size-5" />
              <span>{t("Fast Delivery")}</span>
            </div>
          </div>

          <div className="items-center hidden text-sm lg:flex">
            <ServiceDropdown />
            <div
              className={`flex items-center gap-1.5 px-2 ${
                language === "en" ? "border-r" : "border-l"
              } border-white`}
            >
              <ContactUsIcon className="size-4" />
              <Link href={"/contact-us"}>{t("Contact Us")}</Link>{" "}
              <Link href={"tel:8002440277"}>: 8002440277</Link>
            </div>
            <div
              className={`flex items-center gap-1.5 ${
                language === "en" ? "pl-2" : "pr-2"
              }`}
            >
              <LangIcon className="size-5" />
              <LocaleSwitcher />
            </div>
          </div>
        </div>
        <div className="absolute text-white -translate-x-1/2 top-1 sm:top-2 left-1/2">
          <TopHeaderSwiper headerJson={headerJson} />
        </div>
      </header>

      <div className="bg-white">
        <div className="flex items-center justify-between w-11/12 gap-3 py-3 mx-auto bg-white lg:hidden md:flex-wrap">
          <div
            className="flex items-center gap-1.5"
            onClick={() => Context?.dispatch({ type: "trackOrder" })}
          >
            <div className="flex items-center justify-center rounded-full size-4 md:size-7 bg-primary">
              <GpsIcon className="text-white size-3 md:size-4" />
            </div>
            <span className="text-xs font-semibold md:text-sm text-secondary-900">
              {t("Track Your Order")}
            </span>
          </div>
          <div className="flex items-center gap-1.5">
            <LangIcon className="text-primary-800 size:4 md:size-7" />
            <div className="text-xs font-semibold md:text-sm text-secondary-900">
              <LocaleSwitcher isResponsive={isResponsive} />
            </div>
          </div>
          <div className="flex items-center gap-1.5">
            <div className="flex items-center justify-center rounded-full size-4 md:size-7 bg-primary">
              <ContactUsIcon className="text-white size-3 md:size-4" />
            </div>
            <div className="text-xs font-semibold md:text-sm text-secondary-900">
              <Link prefetch={false} href={"/contact-us"}>
                {t("Contact Us")}
              </Link>{" "}
              <Link prefetch={false} href={"tel:8002440277"}>
                : 8002440277
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
